var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWatchUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#E0E1EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 44.25C37.0939 44.25 43.25 38.0939 43.25 30.5C43.25 22.9061 37.0939 16.75 29.5 16.75C21.9061 16.75 15.75 22.9061 15.75 30.5C15.75 38.0939 21.9061 44.25 29.5 44.25Z",
    stroke: "#2C357D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 22.25V30.5L35 33.25",
    stroke: "#2C357D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchUser);
export default __webpack_public_path__ + "static/media/watch_user.4a690e7a1e73750550aa4c402cfca58b.svg";
export { ForwardRef as ReactComponent };